import { User } from '../../getUser/redux/action';

export enum UpdateUserActionTypes {
  NAME_INPUT = 'NAME_INPUT',
  LASTNAME_INPUT = 'LASTNAME_INPUT',
  PHONE_INPUT = 'PHONE_INPUT',
  AVATAR_INPUT = 'AVATAR_INPUT',
  OPEN_UPDATE_USER_MODAL = 'OPEN_UPDATE_USER_MODAL',
  CLOSE_UPDATE_USER_MODAL = 'CLOSE_UPDATE_USER_MODAL',
  UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST',
  UPDATE_USER_SUCCEEDED = 'UPDATE_USER_SUCCEEDED',
  UPDATE_USER_FAILED = 'UPDATE_USER_FAILED',
}

export interface NameInput {
  type: UpdateUserActionTypes.NAME_INPUT;
  name: string;
}

export interface LastnameInput {
  type: UpdateUserActionTypes.LASTNAME_INPUT;
  lastname: string;
}

export interface PhoneInput {
  type: UpdateUserActionTypes.PHONE_INPUT;
  phone: string;
}

export interface AvatarInput {
  type: UpdateUserActionTypes.AVATAR_INPUT;
  photo;
}

export interface OpenUpdateUserModal {
  type: UpdateUserActionTypes.OPEN_UPDATE_USER_MODAL;
}

export interface CloseUpdateUserModal {
  type: UpdateUserActionTypes.CLOSE_UPDATE_USER_MODAL;
}

export interface UpdateUserRequest {
  type: UpdateUserActionTypes.UPDATE_USER_REQUEST;
  input: object;
}

export interface UpdateUserSucceeded {
  type: UpdateUserActionTypes.UPDATE_USER_SUCCEEDED;
  user: User;
}

export interface UpdateUserFailed {
  type: UpdateUserActionTypes.UPDATE_USER_FAILED;
  error: string;
}

export type UpdateUserActions =
  | NameInput
  | LastnameInput
  | PhoneInput
  | AvatarInput
  | OpenUpdateUserModal
  | CloseUpdateUserModal
  | UpdateUserRequest
  | UpdateUserSucceeded
  | UpdateUserFailed;

export function nameInput(name: string): NameInput {
  return {
    type: UpdateUserActionTypes.NAME_INPUT,
    name,
  };
}

export function lastnameInput(lastname: string): LastnameInput {
  return {
    type: UpdateUserActionTypes.LASTNAME_INPUT,
    lastname,
  };
}

export function phoneInput(phone: string): PhoneInput {
  return {
    type: UpdateUserActionTypes.PHONE_INPUT,
    phone,
  };
}

export function avatarInput(photo): AvatarInput {
  return {
    type: UpdateUserActionTypes.AVATAR_INPUT,
    photo,
  };
}

export function openUpdateUserModal(): OpenUpdateUserModal {
  return {
    type: UpdateUserActionTypes.OPEN_UPDATE_USER_MODAL,
  };
}

export function closeUpdateUserModal(): CloseUpdateUserModal {
  return {
    type: UpdateUserActionTypes.CLOSE_UPDATE_USER_MODAL,
  };
}

export function updateUserRequest(input: object): UpdateUserRequest {
  return {
    type: UpdateUserActionTypes.UPDATE_USER_REQUEST,
    input,
  };
}

export function updateUserSucceeded(user: User): UpdateUserSucceeded {
  return {
    type: UpdateUserActionTypes.UPDATE_USER_SUCCEEDED,
    user,
  };
}

export function updateUserFailed(error: string): UpdateUserFailed {
  return {
    type: UpdateUserActionTypes.UPDATE_USER_FAILED,
    error,
  };
}
